import React, { useState } from 'react';
import TagComponent from '../../components/atoms/Tag.Component';

const FAQItem = ({ question, answer, isOpen, onToggle }) => (
  <div className='border-b border-gray-300 py-6 cursor-pointer select-none' onClick={onToggle}>
    <div className='flex justify-between items-start gap-6'>
      <h3 className='text-xl font-semibold text-dark'>{question}</h3>
      <span className='text-3xl font-thin leading-none flex-shrink-0 text-gray-400'>
        {isOpen ? '−' : '+'}
      </span>
    </div>
    {isOpen && (
      <p className='mt-4 text-lg font-light leading-relaxed text-gray-700'>
        {answer}
      </p>
    )}
  </div>
);

const FAQDesktop = ({ lang, tags, title, items }) => {
  const [openIndex, setOpenIndex] = useState(null);
  const toggle = (i) => setOpenIndex(openIndex === i ? null : i);

  return (
    <div className='min-h-[700px] w-full py-20'>
      <div className='flex justify-center'>
        <div className='w-2/3 px-10'>
          <div className='overflow-hidden mb-10'>
            {tags[lang].map((tag, i) => <TagComponent key={i} value={tag} />)}
          </div>
          <div>
            {items.map((item, i) => (
              <FAQItem
                key={i}
                question={item.question[lang]}
                answer={item.answer[lang]}
                isOpen={openIndex === i}
                onToggle={() => toggle(i)}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FAQDesktop;
